import { generateConfig } from "../utils";
import { API_URL_CONFIG_TYPE } from "../types";
export const MSCU = "MSCU";
export const MSNA = "MSNA";
export const TBPR = "TBPR";

export const FE_MSCU = "eclr";
export const FE_MSNA = "ufog";
export const FE_TBPR = "cmon";

export type RegionEndpoint = keyof typeof REGION_API_DOMAIN_MAP;

const { apiGetway: apiGetwayUrl, homeUrl, serviceUrl, escalade: escaladeUrl, mobileUrl } = generateConfig() as API_URL_CONFIG_TYPE;
const region = process.env.REACT_APP_REGION;

export const REGION_MAP = {
    [TBPR]: "默认区域",
    [MSCU]: "欧洲(微软云)",
    // [MSNA]: "微软云(北美)",
}

export const FE_REGION_MAP = {
    [FE_TBPR]: "默认区域",
    [FE_MSCU]: "欧洲(微软云)",
    // [FE_MSNA]: "微软云(北美)",
}

export const REGION_SELECT_LIST = Object.entries(FE_REGION_MAP).map(([key, value]) => ({
    label: value,
    value: key,
}));

// 统一的URL配置定义 write by cursor
interface UrlConfig {
    home: string;
    service: string;
    api: string;
    mobile: string;
    escalade: string;
}

// 根据region动态获取TBPR的URL配置 write by cursor
const getTBPRUrlConfig = (): UrlConfig => {
    if (region === 'eu') {
        return {
            home: "https://home.gs-robot.com",
            service: "https://service.gs-robot.com", 
            api: "bot.gausium-robot.com",
            mobile: "https://mobile.gs-robot.com",
            escalade: "escalade.gs-robot.com"
        };
    } 
    // 临时方案，北美和test环境互通
    else if (region === 'us') {
        return {
            home: "https://home.test.gs-robot.com",
            service: "https://service.test.gs-robot.com",
            api: "bot.test.gs-robot.com", 
            mobile: "https://mobile.test.gs-robot.com",
            escalade: "escalade.test.gs-robot.com"
        };
    } else {
        // region不存在时使用默认配置 write by cursor
        return {
            home: homeUrl,
            service: serviceUrl,
            api: apiGetwayUrl,
            mobile: mobileUrl,
            escalade: escaladeUrl
        };
    }
};

// 统一的区域URL配置映射 write by cursor
const REGION_URL_CONFIGS = {
    [MSCU]: {
        home: "https://home.eu.gausium-robot.com",
        service: "https://service.eu.gausium-robot.com",
        api: "bot.eu.gausium-robot.com",
        mobile: "https://mobile.eu.gausium-robot.com",
        escalade: "escalade.eu.gausium-robot.com"
    },
    [MSNA]: {
        home: "https://home.us.gausium-robot.com",
        service: "https://service.us.gausium-robot.com", 
        api: "bot.us.gausium-robot.com",
        mobile: "https://mobile.us.gausium-robot.com",
        escalade: "escalade.us.gausium-robot.com"
    },
    [TBPR]: getTBPRUrlConfig()
};

// 导出各个URL映射对象，保持外部访问方式不变 write by cursor
export const REGION_HOME_URL_MAP = {
    [MSCU]: REGION_URL_CONFIGS[MSCU].home,
    [MSNA]: REGION_URL_CONFIGS[MSNA].home,
    [TBPR]: REGION_URL_CONFIGS[TBPR].home,
};

export const REGION_SERVICE_URL_MAP = {
    [MSCU]: REGION_URL_CONFIGS[MSCU].service,
    [MSNA]: REGION_URL_CONFIGS[MSNA].service,
    [TBPR]: REGION_URL_CONFIGS[TBPR].service,
};

export const REGION_DOMAIN_MAP = REGION_SERVICE_URL_MAP;

// 访问service.gs-robot/service.test.gs-robot.com 国内站点，TBPR -》 env lane => serviceUrl ==》 region 不存在
// 访问servie.eu.gausium / service.us.gausium 站点  TBPR -> bot.gs-robot.com 只有生产。
export const REGION_API_DOMAIN_MAP = {
    [MSCU]: REGION_URL_CONFIGS[MSCU].api,
    [MSNA]: REGION_URL_CONFIGS[MSNA].api,
    [TBPR]: REGION_URL_CONFIGS[TBPR].api,
};

export const REGION_MOBILE_URL_MAP = {
    [MSCU]: REGION_URL_CONFIGS[MSCU].mobile,
    [MSNA]: REGION_URL_CONFIGS[MSNA].mobile,
    [TBPR]: REGION_URL_CONFIGS[TBPR].mobile,
};

// socketio地址
export const ESCA_API_DOMAIN_MAP = {
    [MSCU]: REGION_URL_CONFIGS[MSCU].escalade,
    [MSNA]: REGION_URL_CONFIGS[MSNA].escalade,
    [TBPR]: REGION_URL_CONFIGS[TBPR].escalade,
};

export const FE_DC_REGION_MAP = {
    "eclr": MSCU,  // e + "clr" (Europe → "clear" 晴朗，暗示欧洲气候)
    "ufog": MSNA,  // u + "fog" (US → "fog" 雾，暗示北美常见天气)
    "cmon": TBPR,  // c + "mon" (China → "monsoon" 季风，暗示亚洲气候)
}

// 后端的columbus映射前端endpoint的值
export const BE_DC_REGION_MAP = {
    [MSCU]: FE_MSCU,
    [MSNA]: FE_MSNA,
    [TBPR]: FE_TBPR,
}

// 根据后端返回的columbus，获取最终的区域endpoint
export const getRegionEndpoint = (columbus: string | undefined | null): RegionEndpoint => {
    if (columbus === TBPR || !columbus) {
        return TBPR;
    }
    return columbus as RegionEndpoint;
}

// 判断后端返回的columbus是否与当前前端选中区域的 endpoint 一致
export const isEquivalentEndpoint = (columbus: string, endpoint: RegionEndpoint): boolean => {
    return getRegionEndpoint(columbus) === endpoint;
}
